export default __webpack_public_path__ + "static/media/menu-char-l.ccd88979.svg";